import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Sparkles, ChevronRight } from 'lucide-react';
import { useWalkthrough } from '@/contexts/WalkthroughContext';
import { WALKTHROUGH_JOURNEYS } from '@/lib/walkthroughJourneys';

export default function WelcomeTourDialog() {
  const { shouldWelcome, stops, startRun, dismiss, journeyKey } = useWalkthrough();
  const welcome = WALKTHROUGH_JOURNEYS[journeyKey].welcome;

  if (!shouldWelcome) return null;

  return (
    <Dialog open onOpenChange={(open) => { if (!open) dismiss(); }}>
      <DialogContent className="max-w-lg gap-0 overflow-hidden rounded-2xl p-0 sm:rounded-2xl [&>button[aria-label=Close]]:text-white">
        {/* Brand hero */}
        <div className="relative bg-gradient-to-br from-[#E51636] via-[#cf1330] to-[#8f0d21] px-6 pb-6 pt-7 text-white">
          <div className="pointer-events-none absolute -right-12 -top-14 h-44 w-44 rounded-full bg-white/10" />
          <div className="relative flex h-11 w-11 items-center justify-center rounded-2xl bg-white/15">
            <Sparkles className="h-6 w-6" />
          </div>
          <DialogTitle className="relative mt-3.5 text-[22px] font-bold leading-tight tracking-tight text-white">
            {welcome.title}
          </DialogTitle>
          <DialogDescription className="relative mt-1.5 text-[15px] leading-relaxed text-white/85">
            {welcome.sub}
          </DialogDescription>
        </div>

        {/* Tour itinerary — read-only numbered list */}
        <div className="mx-6 mt-4 max-h-[38vh] overflow-y-auto rounded-xl border border-gray-100 bg-gray-50/50">
          <div className="divide-y divide-gray-100">
            {stops.map((s, i) => (
              // index in the key: journeys can visit the same route twice
              // (leader: area guided-create + area dashboard)
              <div key={`${i}-${s.route}`} className="flex items-center gap-3 px-3.5 py-2.5">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#E51636]/10 text-xs font-semibold tabular-nums text-[#E51636]">
                  {i + 1}
                </span>
                <p className="min-w-0 flex-1 truncate text-sm font-medium text-gray-800">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Footer actions */}
        <div className="flex items-center justify-end gap-1.5 px-6 py-4">
          <Button variant="ghost" className="text-gray-500" onClick={dismiss}>
            Not now
          </Button>
          <Button
            className="h-11 rounded-xl bg-[#E51636] px-6 font-semibold text-white shadow-md shadow-[#E51636]/30 hover:bg-[#c91230]"
            onClick={startRun}
          >
            Start the tour <ChevronRight className="ml-1 h-4 w-4" />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
